<ui-headline-wrapper>
    <ui-headline [title]="'modules.programs.blank' | translate" />
</ui-headline-wrapper>

<div class="container-fluid p-md-8 p-4">
    <div class="row">
        <div class="col-12 col-lg-6">
            @if (selectedB2bProgramType === b2bProgramType.NumberOfTrips) {
                <b2b-program-number-of-trips-form
                    [tickets]="tickets$ | async"
                    [prgId]="null"
                    [b2bProgramType]="selectedB2bProgramType"
                    [services]="services$ | async"
                    [partners]="partners$ | async"
                    [pending]="pending$ | async"
                    (submitForm)="handlerAddProgram($event)"
                    (changeService)="handlerChangeService($event)" />
            } @else {
                <b2b-program-single-product-form
                    [prgId]="null"
                    [unit]="units"
                    [type]="rateTypes"
                    [b2bProgramType]="selectedB2bProgramType"
                    [tickets]="tickets$ | async"
                    [services]="services$ | async"
                    [partners]="partners$ | async"
                    [pending]="pending$ | async"
                    (submitForm)="handlerAddProgram($event)"
                    (changeService)="handlerChangeService($event)" />
            }
        </div>
    </div>
</div>
